/**
 * @file index.js
 * @author fanshuang
 * @desc 法典权益
 */

import bendsdk from '@baidu/bend-plugin-sdk';

const routes = [
    {
        path: '/lawcodex',
        name: 'lawcodex',
        meta: {},
        component: () => import('./views/index')
    },
    {
        path: '/lawcodex/edit',
        name: 'lawcodexEdit',
        meta: {},
        component: () => import('./views/edit')
    },
    {
        path: '/lawcodex/detail',
        name: 'lawcodexDetail',
        meta: {},
        component: () => import('./views/detail')
    },
    {
        path: '/lawcodex/guide',
        name: 'lawcodexGuide',
        meta: {},
        component: () => import('./views/guide')
    }
];

export default class lawcodex extends bendsdk.plugin {
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}
